const spinnerStore = {
  namespaced: 'SPINNER',
  state: {
    common_loading_status: false, // 공통 스피너 상태
    app_loading_status: false, // 신청서 스피너 상태
    loading_color_type: 'main', // 스피너 컬러타입 (default)
  },
  getters: {
    GET_COMMON_LOADING_STATUS(state) {
      return state.common_loading_status;
    },
    GET_APP_LOADING_STATUS(state) {
      return state.app_loading_status;
    },
  },
  mutations: {
    ON_COMMON_SPINNER(state, colorType) {
      state.common_loading_status = true;

      if (colorType === undefined || colorType === '') {
        state.loading_color_type = 'main';
      } else {
        state.loading_color_type = colorType;
      }
    },
    OFF_COMMON_SPINNER(state) {
      state.common_loading_status = false;
    },
    ON_APP_SPINNER(state) {
      state.app_loading_status = true;
    },
    OFF_APP_SPINNER(state) {
      state.app_loading_status = false;
    },
  },
};
export default spinnerStore;
